module.exports = __webpack_public_path__ + "img/consulta-adultos.0a128866.jpg";